"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[76],{

/***/ 35076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PromotionsTemplate; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(88756);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.13.0_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(12851);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.9.0-snapshot.1_@bucketplace+ui@1.1.0_@emotion+react@11.13.3_@emo_kg77ydgzcrrvpcndyvt2t3vqny/node_modules/@bucketplace/design-system/dist/esm/foundation.js
var foundation = __webpack_require__(90671);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+common@6.0.0_@bucketplace+config@0.1.2_@bucketplace+design-system@5.9.0-snapshot_mnaeigxo3rapupzl32u5o3bze4/node_modules/@bucketplace/common/dist/index.es.js
var index_es = __webpack_require__(7394);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+jsx-editor@4.0.17_@bucketplace+bucket-log@1.2.3_@bucketplace+commerce-admin-ui@2_iylemcmyljcqx6pqfkw5yjqwhy/node_modules/@bucketplace/jsx-editor/lib-esm/index.js + 547 modules
var lib_esm = __webpack_require__(63047);
// EXTERNAL MODULE: ./src/styles/grids.ts
var grids = __webpack_require__(81213);
// EXTERNAL MODULE: ./src/components/EndModal.tsx
var EndModal = __webpack_require__(80344);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(57390);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(6325);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(78838);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/router.js
var next_router = __webpack_require__(17966);
// EXTERNAL MODULE: ./node_modules/.pnpm/swr@1.3.0_react@18.3.1/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(75182);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(52814);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+ui@1.1.0_@emotion+react@11.13.3_@emotion+styled@11.13.0_react-dom@18.3.1_react@18.3.1_scheduler@0.23.2/node_modules/@bucketplace/ui/lib-esm/index.js + 45 modules
var ui_lib_esm = __webpack_require__(540);
// EXTERNAL MODULE: ./src/promotions/api/promotion.ts
var promotion = __webpack_require__(2118);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.26.0_react-dom@18.3.1_react@18.3.1_sass@1.80.4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(85922);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js
var classnames = __webpack_require__(82187);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bucketplace+design-system@5.9.0-snapshot.1_@bucketplace+ui@1.1.0_@emotion+react@11.13.3_@emo_kg77ydgzcrrvpcndyvt2t3vqny/node_modules/@bucketplace/design-system/dist/esm/bds.js + 59 modules
var bds = __webpack_require__(93353);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(83128);
;// CONCATENATED MODULE: ./src/components/VirtualizedList.tsx




var _templateObject, _templateObject2;

var _excluded = ["gap", "column", "className", "innerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








function VirtualizedList(_ref) {
  var _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? bds/* DEFAULT_GAP */.SHs : _ref$gap,
      column = _ref.column,
      className = _ref.className,
      innerClassName = _ref.innerClassName,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* ClassNames */.ms, {
    children: function children(_ref2) {
      var css = _ref2.css;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ui_lib_esm/* VirtualizedList */.Jd, _objectSpread({
        className: classnames_default()(className, css(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n              display: flex;\n              flex-wrap: wrap;\n              ", ";\n            "])), (0,grids/* cssGridGap */.iC)(gap))),
        innerClassName: classnames_default()(innerClassName, css(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n              box-sizing: border-box;\n              display: inline-block;\n              vertical-align: top;\n              ", ";\n              ", ";\n            "])), (0,grids/* cssGridItemGap */.cf)(gap), (0,grids/* cssColumn */.XG)(column)))
      }, props));
    }
  });
}
;// CONCATENATED MODULE: ./src/components/PlaceholderAnim.tsx



var PlaceholderAnim_templateObject;




function PlaceholderAnim(props) {
  var children = props.children,
      className = props.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
    className: className,
    children: children
  });
}
var placeholderAnim = (0,emotion_react_browser_esm/* keyframes */.F4)(PlaceholderAnim_templateObject || (PlaceholderAnim_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {\n    transform: translate3d(-30%, 0, 0);\n  }\n  100% {\n    transform: translate3d(30%, 0, 0);\n  }\n"])));

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1vo9eey0"
} : 0)("position:relative;display:block;overflow:hidden;", function (_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("color:", theme.content.base5, ";background-color:", theme.content.base5, ";" + ( true ? "" : 0),  true ? "" : 0);
}, " &:after{content:'\\00a0';position:absolute;top:0;right:0;bottom:0;left:50%;z-index:1;width:500%;margin-left:-250%;animation:", placeholderAnim, " 0.8s linear infinite;background:linear-gradient(to right,\n      rgba(255, 255, 255, 0) 44%,\n      rgba(255, 255, 255, .35) 50%,\n      rgba(255, 255, 255, 0) 56%) 50% 50%;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/components/Product/ProductCardWithScrap.tsx
var ProductCardWithScrap = __webpack_require__(476);
;// CONCATENATED MODULE: ./src/promotions/components/SectionStoreItems.tsx




var SectionStoreItems_templateObject, SectionStoreItems_templateObject2;



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var LIST_SIZE = 20;
function getSectionItemsKey(id, detailId) {
  return "/api/promotions/".concat(id, "/section-items?detail=").concat(detailId);
}
function SectionStoreItems(_ref) {
  var id = _ref.id,
      detailId = _ref.detailId;
  var router = (0,next_router.useRouter)();
  var tabId = router.asPath;

  var _useSWR = (0,dist/* default */.ZP)(getSectionItemsKey(id, detailId), function () {
    return (0,promotion/* getSectionItems */.NX)(id, detailId, {
      page: 0
    });
  }),
      data = _useSWR.data,
      error = _useSWR.error;

  var pending = !data && !error;

  var _usePagedInfiniteList = (0,ui_lib_esm/* usePagedInfiniteList */.mw)(tabId, pending, /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(page) {
      var _nextData$sectionItem, _nextData$hasNext;

      var nextData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,promotion/* getSectionItems */.NX)(id, detailId, {
                page: page
              });

            case 2:
              nextData = _context.sent;
              return _context.abrupt("return", {
                page: page,
                items: (_nextData$sectionItem = nextData.sectionItems) !== null && _nextData$sectionItem !== void 0 ? _nextData$sectionItem : [],
                hasNext: (_nextData$hasNext = nextData.hasNext) !== null && _nextData$hasNext !== void 0 ? _nextData$hasNext : false
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), function () {
    var _data$sectionItems, _data$hasNext;

    return data ? {
      page: 0,
      offset: 0,
      items: (_data$sectionItems = data.sectionItems) !== null && _data$sectionItems !== void 0 ? _data$sectionItems : [],
      hasNext: (_data$hasNext = data.hasNext) !== null && _data$hasNext !== void 0 ? _data$hasNext : false
    } : null;
  }, LIST_SIZE),
      count = _usePagedInfiniteList.count,
      getItem = _usePagedInfiniteList.getItem,
      handleRowsRendered = _usePagedInfiniteList.handleRowsRendered;

  var renderItem = function renderItem(_ref3) {
    var _getItem;

    var index = _ref3.index;
    var item = (_getItem = getItem(index)) === null || _getItem === void 0 ? void 0 : _getItem.item;

    if (!item) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlaceholderAnim, {});
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductCardWithScrap/* ProductCardWithScrap */.u, {
      product: item,
      logData: {
        section: '기획전 디테일',
        index: index
      }
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: !pending && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* ClassNames */.ms, {
      children: function children(_ref4) {
        var css = _ref4.css;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VirtualizedList, {
          tabId: tabId,
          gap: {
            mobile: '0 16',
            tablet: '30 16',
            laptop: '30 20'
          },
          column: {
            mobile: 2,
            tablet: 2,
            laptop: 3
          },
          className: css(SectionStoreItems_templateObject || (SectionStoreItems_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n              ", "\n              "])), foundation.M.max('mobile', "\n                  padding: 0 8px;\n                ")),
          innerClassName: css(SectionStoreItems_templateObject2 || (SectionStoreItems_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n                > article {\n                  padding: 16px 0px;\n                }\n                &:last-of-type {\n                  > article {\n                    border: 0;\n                  }\n                }\n              "]))),
          overscanHeight: 1000,
          count: count,
          isLoaded: function isLoaded(index) {
            return getItem(index) != null;
          },
          onRowsRendered: handleRowsRendered,
          renderItem: renderItem
        });
      }
    })
  });
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efch3kp0"
} : 0)(foundation.M.max('mobile',  true ? {
  name: "1qu8ll8",
  styles: "padding:0 8px"
} : 0), ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/promotions/components/SectionViewer.tsx + 4 modules
var SectionViewer = __webpack_require__(43005);
;// CONCATENATED MODULE: ./src/promotions/components/PromotionsTemplate.tsx



function PromotionsTemplate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PromotionsTemplate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PromotionsTemplate_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PromotionsTemplate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











function PromotionsTemplate(_ref) {
  var units = _ref.units,
      promotionId = _ref.promotionId,
      title = _ref.title,
      coverImageUrls = _ref.coverImageUrls,
      detailId = _ref.detailId,
      anchorInfo = _ref.anchorInfo,
      endDate = _ref.endDate,
      isLoading = _ref.isLoading,
      className = _ref.className,
      onViewerLoaded = _ref.onViewerLoaded;

  var _useScrollIntoAnchor = (0,lib_esm/* useScrollIntoAnchor */.xx)(PromotionsTemplate_objectSpread(PromotionsTemplate_objectSpread({}, anchorInfo), {}, {
    isLoading: isLoading,
    initialAnchor: anchorInfo.isInitialAnchor
  })),
      containerRef = _useScrollIntoAnchor.containerRef,
      scrollToTarget = _useScrollIntoAnchor.scrollToTarget,
      anchorEnd = _useScrollIntoAnchor.anchorEnd;

  var kakaoTemplate = (0,react.useMemo)(function () {
    return (0,index_es/* getExhibitionKakaoTemplate */.Zsj)({
      exhibitionId: promotionId,
      title: title,
      coverImageUrls: coverImageUrls !== null && coverImageUrls !== void 0 ? coverImageUrls : [],
      products: []
    });
  }, [coverImageUrls, promotionId, title]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PromotionsTemplate_Container, {
    ref: function ref(_ref2) {
      if (anchorEnd || !anchorInfo.isInitialAnchor) {
        containerRef.current = null;
      } else {
        containerRef.current = _ref2;
      }
    },
    className: className,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GridItem, {
      column: {
        mobile: 'full',
        tablet: 'full',
        laptop: 9
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionViewer/* SectionViewer */.k, {
        exhibitionId: promotionId,
        units: units,
        kakaoTemplate: kakaoTemplate,
        experimentType: null,
        onViewerLoaded: onViewerLoaded,
        onClick: scrollToTarget
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionStoreItems, {
        id: promotionId,
        detailId: detailId
      })]
    }), endDate && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EndModal/* EndModal */.Y, {
      title: "\uC774\uBCA4\uD2B8 \uC885\uB8CC",
      contents: "\uD574\uB2F9 \uC774\uBCA4\uD2B8\uAC00 \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
      end: endDate,
      redirectTarget: "store"
    })]
  });
}

var PromotionsTemplate_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1chq35i1"
} : 0)("display:flex;flex-wrap:wrap;max-width:", foundation.B.desktop, "px;margin:0 auto;padding:30px 60px;", foundation.M.max('tablet', "\n    padding: 0;\n  "), ";" + ( true ? "" : 0));

var GridItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1chq35i0"
} : 0)("position:relative;margin:0 auto;", function (_ref3) {
  var column = _ref3.column;
  return (0,grids/* cssColumn */.XG)(column);
}, ";" + ( true ? "" : 0));

/***/ })

}]);